import React, { PropsWithChildren } from 'react'
import { ICONS, IconType } from '@Const/common'
import clsx from 'clsx'
import './index.scss'

interface CatalogTransferTypeBoxProps {
    icon?: IconType
    heading: string
    onClick: () => void
    className?: string
}

const Index = ({ icon, heading, children, onClick, className }: PropsWithChildren<CatalogTransferTypeBoxProps>) => (
    <div className={clsx('catalog-transfer-type-box', className)} onClick={onClick}>
        {icon && <img className="catalog-transfer-type-box__icon" src={ICONS[icon]} alt={heading + ' icon'} />}
        <h3 className="catalog-transfer-type-box__heading">{heading}</h3>
        <div className="catalog-transfer-type-box__content">{children}</div>
    </div>
)

export default Index
